<template>
  <tr :class="{ loading: loading }">
    <td class="clickable" @click="toggleShowOfficeInfo(office.id)">
      <a-icon :type="showOfficeInfo ? 'down' : 'right'"/>
      {{ office.name }}
    </td>

    <td class="compact text-center">
      <user-badge-group v-if="ownerIds.length" :user-ids="ownerIds"/>
      <span v-else>-</span>
    </td>

    <td class="compact text-center">
      {{ 'users_count' in office ? office.users_count.data.count : '-' }}
    </td>

    <td class="compact text-center">
      {{ 'customers_count' in office ? office.customers_count.data.count : '-' }}
    </td>

    <td class="text-right compact">
      <a-button type="primary"
                @click="edit(office.id)"
                :size="buttonSize"
                title="Kantoor bewerken">
        <pencil-icon></pencil-icon>
      </a-button>

      <a-button @click="editStyle(office.id)"
                :size="buttonSize"
                title="Kantoor huisstijl aanpassen">
        <palette-icon></palette-icon>
      </a-button>

      <a-popconfirm
          :title="`Weet u zeker dat u dit kantoor (${ office.name }) wilt verwijderen?`"
          ok-text="Ja"
          cancel-text="Annuleer"
          @confirm="confirmedDelete(office.id)"
      >
        <a-button type="danger"
                  :size="buttonSize"
                  title="Kantoor verwijderen">
          <delete-icon></delete-icon>
        </a-button>
      </a-popconfirm>
    </td>
  </tr>
</template>

<script>
import officeApi from '~/api/office';

export default {
  name: "OfficeRowComponent",
  props: {
    id: {
      type: Number,
      required: true
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
  },
  data() {
    return {
      loading: false,
      office: {},
      ownerIds: [],
      showOfficeInfo: false,
    }
  },
  mounted() {
    if (this.id) {
      this.loading = true;
      officeApi.find(this.id, ['owners', 'users', 'customers_count', 'users_count'])
          .then(response => {
            this.office = response.data;
            this.getOwnerIds();
          })
          .catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om de kantoor gegevens te laden',
            });
          })
          .finally(() => {
            this.loading = false;
          });
    }
  },
  methods: {
    getOwnerIds() {
      if ('owners' in this.office) {
        if (this.office.owners.data.length) {
          this.office.owners.data.forEach(owner => {
            this.ownerIds.push(owner.id)
          });
        }
      }
    },
    edit(officeId) {
      window.location.href = `/settings/organization/office/${officeId}`;
    },
    editStyle(officeId) {
      window.location.href = `/settings/organization/office/${officeId}/style`;
    },
    confirmedDelete(officeId) {
      this.loading = true;
      officeApi.delete(officeId)
          .then(() => {
            this.$notification['success']({
              message: 'Success',
              description: 'Het kantoor is verwijderd',
            });
            this.$emit('deleted', officeId);
          })
          .catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt het kantoor te verwijderen',
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    toggleShowOfficeInfo() {
      this.showOfficeInfo = !this.showOfficeInfo;
      this.$emit('toggleShowOfficeInfo');
    },
  },
}
</script>

<style scoped>
.loading {
  opacity: .5;
}

.clickable {
  cursor: pointer;
}
</style>